import { IndustryTemplate } from '@/components';
import { landscapingContent } from '@/data/industries/landscaping';

export function LandscapingPage() {
  return <IndustryTemplate content={landscapingContent} />;
}
